import React, {useState, useContext} from 'react';
import { Text, Pressable, View } from 'react-native';
import {
  Card,
  LinkContainer,
  LinkSpace
} from 'app/src/elements';
import moment from 'moment';
import { Link } from 'app/src/utils/routing';
import {
  getStatusType,
  getStatus,
  NameLabel,
  StatusLabel,
  NameStatusLabel,
  BoldText
} from 'app/src/components/Sales/elements';
import AuthContext from '../contexts/AuthContext';

const SaleCard = props => {
  const { sale } = props;
  const { hasPolicy } = useContext(AuthContext);

  return (
    <Card style={{border: `3px solid ${getStatusType(sale?.status)}`}}>
      <NameStatusLabel>
        <NameLabel>
          <Link to={`/sales/${sale.id}`}>
            <BoldText>{sale.name}</BoldText>
          </Link>
        </NameLabel>
        <StatusLabel style={{color: getStatusType(sale?.status)}}>
          <BoldText>{getStatus(sale?.status)}</BoldText>
        </StatusLabel>

      </NameStatusLabel>
      <LinkContainer style={{marginTop: '-5px', marginBottom: '25px'}}>
        {hasPolicy({ type: 'Sale', action: 'auctioneer' }) && (
          <>
            <Link to={`/bidding/auctioneer/${sale.id}`}>
              <BoldText style={{color: getStatusType(sale?.status)}}>
                Auctioneer
              </BoldText>
            </Link>
            {/* <Text>{' | '}</Text> */}
          </>
        )}
        {hasPolicy({ type: 'Sale', action: 'clerk' }) && (
          <>
            <Text>{' | '}</Text>
            <Link to={`/bidding/clerk/${sale.id}`}>
              <BoldText style={{color: getStatusType(sale?.status)}}>
                Clerk
              </BoldText>
            </Link>
          </>
        )}
        {hasPolicy({ type: 'Sale', action: 'auctioneer' }) && (
          <>
            <Text>{' | '}</Text>
            <Link to={`/bidding/hud/${sale.id}`}>
              <BoldText style={{color: getStatusType(sale?.status)}}>
                HUD
              </BoldText>
            </Link>
          </>
        )}
      </LinkContainer>
      <Text>Sale Date: {moment(sale.saleOn).format('M-DD-YY')}</Text>
      <Text>Number of Assets: {sale.visibleSaleAssetsCount}</Text>
    </Card>
  )
}

export default SaleCard;
